export default __webpack_public_path__ + "static/media/team_03.679d7294.jpg";